/*
Scripts File
Author: King Louis, LLC

This file should contain any js scripts you want to add to the site.
Instead of calling it in the header or throwing it inside wp_head()
this file will be called automatically in the footer so as not to
slow the page load.

*/

// (function (l) { var i, s = { touchend: function () { } }; for (i in s) l.addEventListener(i, s) })(document); // sticky hover fix in iOS





/** =======================================================================
		DOCUMENT READY FUNCTIONS
	======================================================================== */
// as the page loads, call these scripts
jQuery(document).ready(function ($) {

	jQuery('.no-scroll>a, a.no-scroll').on('click', (function (event) {
		event.preventDefault();
	}));


	if (window.location.hash) {
		var hash = window.location.hash;
		setTimeout(function () {
			$('html, body').animate({
				scrollTop: $(hash).offset().top - 80
			}, 600);
		}, 100);

	}



	/* -------------------------------------------
		Slick Slider
	------------------------------------------- */
	$('#client-list').slick({
		infinite: true,
		slidesToShow: 7,
		slidesToScroll: 1,
		dots: false,
		centerMode: true,
		variableWidth: true,
		autoplay: true,
		autoplaySpeed: 0,
		speed: 2000,
		arrows: false,
		cssEase: 'linear',
		touchMove: false,
		draggable: false,
		swipe: false,
		responsive: [{
			breakpoint: 1199,
			settings: {
				slidesToShow: 5
			}
		},
		{
			breakpoint: 767,
			settings: {
				slidesToShow: 3
			}
		}
		]
	});


	$('#testimonial-list').slick({
		// infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		dots: true,
		arrows: true,
		autoplay: false,
		autoplaySpeed: 4000,
		speed: 1000,
		pauseOnHover: true,
		draggable: false,
	});


	/* -------------------------------------------
			ScrollMagic
		------------------------------------------- */

	// init controller
	var controller = new ScrollMagic.Controller();

	function lineExpandFunc() {
		$('.hero-text strong, .hero-text b, .animated-strong strong, .animated b').each(function () {
			var targetElem = $(this).parent();
			var targetHeight = $(targetElem).height();
			var lineExpand = new ScrollMagic.Scene({
				triggerElement: targetElem[0],
				triggerHook: .7,
				offset: 0
				// duration: targetHeight,
			})
				.setClassToggle(this, 'animate')
				// .removeClassToggle(true)
				// .addIndicators()
				.addTo(controller);

			var lineContract = new ScrollMagic.Scene({
				triggerElement: targetElem[0],
				triggerHook: .1,
				offset: targetHeight
				// duration: targetHeight,
			})
				.setClassToggle(this, 'animate-out')
				// .removeClassToggle(true)
				// .addIndicators()
				.addTo(controller);
		})
	}

	function flyInHeroFunc() {
		$('.flyInHero').each(function () {
			var targetElem = $(this).parent('.animateTrigger');
			var targetHeight = $(this).height();
			var video = $(this)[0];
			//    console.log(targetHeight);
			var triggerIn = 0.45;
			var triggerOut = 0.08;
			if ($(window).width() < 768) {
				var triggerIn = 0.48;
				var triggerOut = 0.12;
			}

			var flyIn = new ScrollMagic.Scene({
				triggerElement: targetElem[0],
				triggerHook: triggerIn,
				offset: 0,
				// duration: targetHeight,
			})
				.setClassToggle(this, 'animate')
				// .addIndicators()
				.addTo(controller)
				.on('enter', function (e) {
					video.play();
					// console.log('play');
				}).on('leave', function (e) {
					video.pause();
					// console.log('pause');
				});

			var flyOut = new ScrollMagic.Scene({
				triggerElement: targetElem[0],
				triggerHook: triggerOut,
				offset: targetHeight,
			})
				.setClassToggle(this, 'animate-out')
				// .addIndicators({ colorStart: "#c20c3c", indent: 100 })
				.addTo(controller)
				.on('enter', function (e) {
					video.pause();
					// console.log('pause 2');
				})
				.on('leave', function (e) {
					video.play();
					// console.log('play 2');
				});
		});
	}

	function flyInFunc() {
		$('.flyIn').each(function () {
			var targetElem = $(this).parent('.animateTrigger');
			var targetHeight = $(this).height();
			var triggerIn = 0.9;
			var triggerOut = 0.08;
			if ($(window).width() < 768) {
				var triggerIn = 0.95;
				var triggerOut = 0.09;
			}

			var flyIn = new ScrollMagic.Scene({
				triggerElement: targetElem[0],
				triggerHook: triggerIn,
				offset: 0,
			})
				.setClassToggle(this, 'animate')
				// .addIndicators()
				.addTo(controller);

			var flyOut = new ScrollMagic.Scene({
				triggerElement: targetElem[0],
				triggerHook: triggerOut,
				offset: targetHeight,
			})
				.setClassToggle(this, 'animate-out')
				// .addIndicators({ colorStart: "#c20c3c", indent: 100 })
				.addTo(controller);
		});
	}


	function circleDrawFunc() {
		$('.play-step').each(function () {
			var targetHeight = $(this).height();
			var triggerIn = 0.8;
			if ($(window).width() < 768) {
				var triggerIn = 0.8;
			}
			var flyIn = new ScrollMagic.Scene({
				triggerElement: this,
				triggerHook: triggerIn,
				offset: 0,
			})
				.setClassToggle(this, 'animate')
				// .addIndicators()
				.addTo(controller);
		});
	}

	function stagesFunc() {
		$('.stage').each(function () {
			var targetHeight = $(this).height() - 20;
			var targetElem = $(this).children('.animate-me');
			var triggerIn = 0.8;
			var triggerOut = 0.08;
			if ($(window).width() < 768) {
				var triggerIn = 0.95;
				var triggerOut = 0.09;
			}

			var flyIn = new ScrollMagic.Scene({
				triggerElement: this,
				triggerHook: triggerIn,
				offset: 0,
			})
				.setClassToggle(targetElem[0], 'animate')
				// .addIndicators()
				.addTo(controller);

			var flyOut = new ScrollMagic.Scene({
				triggerElement: this,
				triggerHook: triggerOut,
				offset: targetHeight,
			})
				.setClassToggle(targetElem[0], 'animate-out')
				// .addIndicators({ colorStart: "#c20c3c", indent: 100 })
				.addTo(controller);
		});
	}

	function processFunc() {

		if (window.innerWidth > 767) {

			var stickyOffset = $('#process-text').outerHeight();

			var cardHeight = $('#the-process .card').outerHeight();

			var processInner = $('#the-process').height();

			var stickyDuration = processInner - cardHeight;

			$('.card').css('top', stickyOffset);



			var processSection = new ScrollMagic.Scene({
				triggerElement: '#process-text',
				triggerHook: 0,
				offset: 0,
				duration: stickyDuration
			})
				.setPin('#process-text', { pushFollowers: false })
				// .addIndicators()
				.addTo(controller);
		}
	} // end if larger than 797px



	function testimonialStartStop() {

		var targetHeight = $('#testimonial-list').height();
		//    console.log(targetHeight);
		var triggerIn = 0.7;
		// if ($(window).width() < 768) {
		// 	var triggerIn = 0.48;
		// 	var triggerOut = 0.12;
		// }

		var testimonialStart = new ScrollMagic.Scene({
			triggerElement: '#testimonial-list',
			triggerHook: triggerIn,
			offset: 0,
			duration: targetHeight * 2,
		})

			// .addIndicators()
			.addTo(controller)
			.on('enter', function (e) {
				$('#testimonial-list').slick('slickPlay');
				// console.log('play');
			}).on('leave', function (e) {
				$('#testimonial-list').slick('slickPause').slick('slickGoTo', 0);
				// console.log('pause');
			});

			// var flyOut = new ScrollMagic.Scene({
			// 	triggerElement: targetElem[0],
			// 	triggerHook: triggerOut,
			// 	offset: targetHeight,
			// })
			// 	.setClassToggle(this, 'animate-out')
			// 	// .addIndicators({ colorStart: "#c20c3c", indent: 100 })
			// 	.addTo(controller)
			// 	.on('enter', function (e) {
			// 		video.pause();
			// 		// console.log('pause 2');
			// 	})
			// 	.on('leave', function (e) {
			// 		video.play();
			// 		// console.log('play 2');
			// 	});
	}




lineExpandFunc();
flyInHeroFunc();
flyInFunc();
circleDrawFunc();
stagesFunc();
processFunc();
testimonialStartStop();

/* -------------------------------------------
		Video Modals
	------------------------------------------- */

$('.video-modal').on('shown.bs.modal', function (e) {
	var vid = $(this).find('video');
	vid[0].play();
}).on('hide.bs.modal', function (e) {
	var vid = $(this).find('video');
	vid[0].pause();
}).on('hidden.bs.modal', function (e) {
	var vid = $(this).find('video');
	vid[0].load();
});

/* -------------------------------------------
		Demo Modals
	------------------------------------------- */

jQuery('[href^="#demo"]:not([data-toggle])').click(function (e) {
	e.preventDefault();
	$('#demo').modal('show');
})



}); /* end of as page load scripts */



/** =======================================================================
	UTILITY FUNCTIONS
======================================================================== */
